import { FilterKindEnum } from '../../../../../domains/global-filters/model/FilterChain';
import type { Experiment } from '../../../../../domains/experiments/model/Experiment';
import { getLabels } from '../../../../../utils/LabelFormatter/SingleLabelFormatter/ExperimentLabelFormatter';
import { getFilterMetadata } from '../../../FilterChainUtils';
import type { AbstractSingleFilterPillsProps } from '../../SingleFilterType';
import type { ExperimentType } from '../ExperimentFilterType';
import { ExperimentFilter } from '../ExperimentFilter';

interface UnbounceFilterFilterProps extends AbstractSingleFilterPillsProps<ExperimentType> {
  optionList?: Experiment[];
  optionListIsLoading: boolean;
  isIntegrationActive: boolean;
}

export function UnbounceFilter({
  currentValue,
  autoFocus,
  onApply,
  onRemove,
  onDropdownHidden,
  showDropdownOnMount,
  optionList = [],
  optionListIsLoading,
  onDropdownShown,
  isIntegrationActive,
}: UnbounceFilterFilterProps): JSX.Element {
  const metadata = getFilterMetadata(FilterKindEnum.Unbounce);
  const { label1, label2 } = getLabels(currentValue, FilterKindEnum.Unbounce);

  return (
    <ExperimentFilter
      autoFocus={autoFocus}
      filterName={metadata.filterName}
      iconName={metadata.iconName}
      currentValue={currentValue}
      onApply={onApply}
      onRemove={onRemove}
      onDropdownHidden={onDropdownHidden}
      showDropdownOnMount={showDropdownOnMount}
      optionList={optionList}
      optionListIsLoading={optionListIsLoading}
      onDropdownShown={onDropdownShown}
      label1={label1}
      label2={label2}
      isIntegrationActive={isIntegrationActive}
    />
  );
}
